<script>
import { axiosGetPost } from '@router/axiosGetPost'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vue2Dropzone from 'vue2-dropzone'

export default {
  name: 'UploadFile',
    components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    requestId: {
      type: [String, Number, Object],
      default: function () {
        return {}
      },
    },
    dzOptions: {
      type: [String, Number, Object],
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      options: [],
      dropzoneOptions: this.dzOptions,
      requestID:this.requestId,
    }
  },
  created() {},
  methods: {
    removeFile() {
      const dataDic = {
        filename: this.dropzoneOptions.fileName,
      }
      axiosGetPost('post', '/requests/delete_file', dataDic).then(
        (response) => {
          let data = response.data
          if (data.success === true) {
            this.dropzoneOptions.fileName = null
          } else {
            this.dropzoneOptions.fileName = null
            this.$toastr.e('Error Delete in Server. Error: ' + data.error)
          }
          return data
        }
      )
    },
    vsuccess(file, response) {
      this.dropzoneOptions.fileName = response.file_name
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="form-group mt-1 mt-sm-0 text-center">
        <h4 style="color: red">{{ dropzoneOptions.detailTemplate }}</h4>
        <vue-dropzone
          id="dropzone"
          ref="myVueDropzone"
          :options="dropzoneOptions"
          :use-custom-slot="true"
          :destroyDropzone="false"
          @vdropzone-removed-file="removeFile"
          @vdropzone-success="vsuccess"
        >
          <div class="text-center">
            <i class="h1 text-muted uil-cloud-upload"></i>
            <h3>Drop files here or click to upload.</h3>
            <span class="text-muted font-size-13">
              (Selected files to be uploaded.)
            </span>
          </div>
        </vue-dropzone>
      </div>
      <b-button
        variant="primary"
        :disabled="!dropzoneOptions.fileName"
        :to="{
          name: 'spreadsheet_detail',
          params: {
            type: 'FCL',
            id: requestID,
          },
          query: {
            preload: dropzoneOptions.fileName,
          },
        }"
      >
        enviar
      </b-button>
    </div>
  </div>
</template>